function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.85 0C5.315 0 0 5.316 0 11.85c0 6.532 5.316 11.848 11.85 11.848 6.532 0 11.848-5.316 11.848-11.849S18.382 0 11.85 0zm0 22.217c-5.718 0-10.369-4.65-10.369-10.368 0-5.717 4.65-10.368 10.368-10.368 5.717 0 10.368 4.65 10.368 10.368 0 5.717-4.65 10.368-10.368 10.368z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.85 11.109c-1.205 0-2.223-.679-2.223-1.482 0-.802 1.018-1.48 2.222-1.48.681 0 1.312.213 1.73.583a.74.74 0 001.046-.062.74.74 0 00-.062-1.046c-.519-.46-1.215-.772-1.973-.895v-.802a.74.74 0 00-1.481 0v.8C9.42 7 8.146 8.196 8.146 9.626c0 1.634 1.662 2.963 3.703 2.963 1.204 0 2.222.678 2.222 1.48 0 .804-1.018 1.482-2.222 1.482-.681 0-1.312-.213-1.73-.584a.738.738 0 00-1.046.063.74.74 0 00.063 1.045c.518.462 1.214.772 1.973.896v.802a.74.74 0 001.48 0v-.8c1.69-.276 2.963-1.472 2.963-2.903 0-1.634-1.662-2.962-3.703-2.962z"
});

function SvgSaleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
}

export default SvgSaleIcon;